import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { CommonModule } from '@angular/common';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RoleLabelPipe } from '@shared/pipes/role-label.pipe';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule, NzAvatarModule, NzDropDownModule, NzIconModule, RoleLabelPipe],
  template: `
    <div
      class="avatar-container"
      nz-dropdown
      [nzDropdownMenu]="menu"
      nzTrigger="click"
      [nzClickHide]="true"
      [nzPlacement]="'bottomRight'"
    >
      <div class="dropdown-trigger">
        <ng-container *ngIf="imageUrl; else initialsBlock">
          <nz-avatar [nzSize]="44" [nzSrc]="imageUrl" nzShape="circle"></nz-avatar>
        </ng-container>
        <ng-template #initialsBlock>
          <nz-avatar
            [nzSize]="44"
            [nzText]="getInitials()"
            nzShape="circle"
            [ngStyle]="{ 'background-color': getColorByName() }"
            class="custom-avatar"
          ></nz-avatar>
        </ng-template>
      </div>
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <div class="avatar-menu-header">
          <div class="avatar-menu-info">
            <div class="avatar-menu-name">{{ getFullName() }}</div>
            <div class="avatar-menu-role" *ngIf="role">{{ role | roleLabel }}</div>
          </div>
        </div>
        <li nz-menu-item (click)="onProfileClick()" (keydown.enter)="onProfileClick()" tabindex="0">
          <span nz-icon nzType="user"></span>
          Profile
        </li>
        <li nz-menu-item (click)="onLogoutClick()" (keydown.enter)="onLogoutClick()" tabindex="0">
          <span nz-icon nzType="logout"></span>
          Logout
        </li>
      </ul>
    </nz-dropdown-menu>
  `,
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  @Input() firstName = '';
  @Input() lastName = '';
  @Input() role = '';
  @Input() imageUrl = '';

  @Output() logout = new EventEmitter<void>();
  @Output() profile = new EventEmitter<void>();

  getInitials(): string {
    const first = this.firstName?.trim();
    const last = this.lastName?.trim();
    if (first && last) {
      return (first[0] + last[0]).toUpperCase();
    }
    if (first) {
      return first.slice(0, 2).toUpperCase();
    }
    return '?';
  }

  getFullName(): string {
    const first = this.firstName?.trim();
    const last = this.lastName?.trim();

    if (first && last) return `${first} ${last}`;
    if (first) return first;
    if (last) return last;
    return 'User';
  }

  onProfileClick(): void {
    this.profile.emit();
  }

  onLogoutClick(): void {
    this.logout.emit();
  }

  getColorByName(): string {
    const str = this.firstName + this.lastName || 'user';
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 65%, 55%)`;
  }
}
